import Carousel from './carousel';

class HeroBlog extends Carousel {
  constructor(selector: any = '.js-hero-blog') {
    const TIME = 5000;
    const SPEED = 800;

    const el: HTMLElement | null = document.querySelector(selector);
    const pagination: HTMLElement | null | undefined = el?.parentElement?.querySelector('.js-hero-blog--pagination');

    super(el, {
      effect: 'slide',
      speed: SPEED,
      slidesPerView: 1,
      spaceBetween: 80,
      loop: true,
      autoplay: {
        delay: TIME,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
      on: {
        afterInit: (swiper: any) => {
          pagination?.style.setProperty('--time', `${(TIME + (SPEED / 2)) / 1000}s`);

          if (swiper.slides.length - 2 <= 1) {
            swiper.autoplay.stop();
            swiper.unsetGrabCursor();
            swiper.params.grabCursor = false;
            swiper.params.loop = false;
          }
        },
      },
      observer: true,
      observeParents: true,
    });
  }

  init() {
    super.init();
  }
}

export default HeroBlog;
